import TextStyle from '@rezdy/components/TextStyle';
import React from 'react';
import { red } from '../constants/theme';

export const RequiredFieldLabel = ({ label, missing }: { label: string; missing?: boolean }) => (
    <TextStyle as="div" style={{ marginTop: 0, marginBottom: 0 }} size="small" weight="bold">
        {label} <span style={{ color: red }}>* {missing && 'Missing'}</span>
    </TextStyle>
);
